import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle, ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "../components/ui/accordion";

const FAQ = () => {
  const { t, lang } = useLanguage();
  const navigate = useNavigate();
  useReveal([lang]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goContact = () => {
    navigate("/");
    setTimeout(() => {
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 280);
  };

  return (
    <div className="App min-h-screen">
      <Header />
      <main className="container-px mx-auto max-w-3xl pt-32 pb-24">
        <div className="reveal text-center">
          <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-white/10 border border-white/20">
            <HelpCircle className="h-7 w-7 text-white" />
          </div>
          <p className="text-xs font-semibold tracking-[0.3em] text-white/50">{t.faq.eyebrow}</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white">
            {t.faq.title}
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/60">{t.faq.subtitle}</p>
        </div>

        <div className="reveal glass-card mt-12 rounded-3xl px-6 py-3 sm:px-9 sm:py-5">
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-white/10"
              >
                <AccordionTrigger className="font-display text-base sm:text-lg font-medium uppercase tracking-wide text-white hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-white/65">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="reveal mt-10 text-center">
          <button onClick={goContact} className="glass-btn-solid glass-btn px-7 py-3.5 text-sm font-semibold">
            {t.nav.cta}
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default FAQ;
